import * as React from 'react';

import * as styles from './button.module.scss';

interface ButtonProps {
  theme: 'primary' | 'secondary';
  size: 'small' | 'medium' | 'large';
  text: string;
  type?: React.ButtonHTMLAttributes<any>['type'];
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const Button = ({theme, size, text, type, disabled, onClick}: ButtonProps) => {
  return (
    <div className={[styles.buttonWrapper, styles[size]].join(' ')}>
      <button
        disabled={disabled}
        className={[styles.button, styles[theme]].join(' ')}
        onClick={onClick ? onClick : undefined}
        type={type}>
        {text}
      </button>
    </div>
  );
};

export default Button;
